// 吃瓜前线 · 首页内容数据

export const tickerItems = [
  "重磅·加急 某爆款选秀节目组被曝内部淘汰名单提前流出",
  "独家 当红小花新剧开机现场路透照抢先曝光",
  "速递 年度盛典红毯时间表公布 三大顶流确认同台",
  "首发 头部主播带货新规本周落地 行业连夜开会",
  "快讯 知名综艺主持人回应此前塌房传闻",
  "加急 演唱会黄牛乱象再上热搜 票务平台紧急声明",
];

export const hero = {
  tag: "独家 · 首发加急",
  category: "影视综艺",
  title: "顶流剧组暗战内幕流出：一场开机礼，牵出三份档期争夺",
  lead: "吃瓜前线独家抢先放出开机礼幕后细节，多位主演档期反复调整的真实原因终于浮出水面——原来竞争早在官宣前就已开始。",
  meta: "编辑 前线阿瓜 · 3 分钟前发布 · 全网首发",
  stats: { read: "128.6万 已读", discuss: "2.3万 讨论" },
  related: ["导演连夜改剧本被拍到", "投资方换人细节曝光", "主题曲演唱者悬念加急"],
  image:
    "https://readdy.ai/api/search-image?query=editorial%20cinematic%20film%20studio%20backstage%20scene%20with%20clapperboard%20and%20spotlights%20in%20warm%20amber%20and%20coral%20tones%2C%20blurred%20crew%20silhouettes%2C%20dramatic%20magazine%20news%20photography%2C%20rich%20warm%20contrast%2C%20high%20detail&width=1600&height=900&seq=hero-breaking-01&orientation=landscape",
};

export const headlines = [
  {
    id: "h1",
    tag: "加急",
    title: "爆款音乐综艺名单意外流出，导师一换再换内情曝光",
    time: "12 分钟前",
    heat: "96",
    category: "综艺",
    image:
      "https://readdy.ai/api/search-image?query=music%20variety%20show%20studio%20with%20neon%20stage%20lights%20in%20warm%20coral%20and%20gold%20tones%2C%20empty%20stage%20spotlight%2C%20editorial%20entertainment%20news%20photography%2C%20moody%20atmosphere&width=800&height=520&seq=head-music-01&orientation=landscape",
  },
  {
    id: "h2",
    tag: "独家",
    title: "小花新剧造型首曝光，路透变装视频被疯传",
    time: "26 分钟前",
    heat: "91",
    category: "影视",
    image:
      "https://readdy.ai/api/search-image?query=period%20drama%20costume%20fabric%20closeup%20with%20brocade%20texture%20and%20hairpin%20accessories%20on%20warm%20paper%20background%2C%20editorial%20behind%20scenes%20photography%2C%20elegant%20warm%20light&width=800&height=520&seq=head-costume-01&orientation=landscape",
  },
  {
    id: "h3",
    tag: "速递",
    title: "年度盛典红毯名单正式公布，三大顶流确认同台",
    time: "41 分钟前",
    heat: "88",
    category: "盛典",
    image:
      "https://readdy.ai/api/search-image?query=red%20carpet%20event%20with%20camera%20flashes%20and%20warm%20spotlight%2C%20crowd%20of%20photographers%20blurred%2C%20glamorous%20awards%20ceremony%2C%20editorial%20press%20photography%2C%20warm%20golden%20tones&width=800&height=520&seq=head-award-01&orientation=landscape",
  },
  {
    id: "h4",
    tag: "首发",
    title: "票务平台深夜加急声明，黄牛锁票软件被点名",
    time: "58 分钟前",
    heat: "84",
    category: "行业",
    image:
      "https://readdy.ai/api/search-image?query=concert%20ticket%20and%20smartphone%20with%20queue%20numbers%20on%20dark%20table%2C%20warm%20amber%20lighting%2C%20editorial%20tech%20news%20photography%2C%20focused%20product%20shot&width=800&height=520&seq=head-ticket-01&orientation=landscape",
  },
];

export const exclusives = [
  {
    id: "e1",
    tag: "独家深挖",
    time: "今日 09:20",
    readMin: "8 分钟深度",
    title: "一场改名风波背后的资本棋局，我们盘了三个月",
    lead: "从商标抢注到更换公司主体，看似突然的改名背后是长达数月的布局。吃瓜前线独家梳理完整时间线，还原行业内的真实操作路径。",
    image:
      "https://readdy.ai/api/search-image?query=stack%20of%20documents%20and%20seal%20stamp%20with%20magnifying%20glass%20on%20warm%20wooden%20desk%2C%20editorial%20investigative%20news%20photography%2C%20warm%20amber%20and%20cream%20tones%2C%20moody&width=700&height=820&seq=excl-doc-01&orientation=portrait",
  },
  {
    id: "e2",
    tag: "独家专访",
    time: "昨日 21:40",
    readMin: "12 分钟深聊",
    title: "和顶流制作人聊了四个小时，他说烂片是被催出来的",
    lead: "一句档期定死了、不拍也得拍道尽行业无奈。这次对话里，他首次讲透工业化流程如何一步步杀死创作。",
    image:
      "https://readdy.ai/api/search-image?query=podcast%20microphone%20and%20notebook%20in%20warm%20studio%20lighting%20with%20bokeh%20background%2C%20editorial%20interview%20photography%2C%20coral%20and%20cream%20color%20palette%2C%20intimate%20mood&width=700&height=820&seq=excl-interview-01&orientation=portrait",
  },
  {
    id: "e3",
    tag: "独家复盘",
    time: "前天 18:05",
    readMin: "6 分钟拆解",
    title: "从全网嘲到真香，这档综艺的逆袭剧本写在哪",
    lead: "首播被骂到热搜，三周后口碑翻盘。吃瓜前线复盘其营销动作与内容改动，看一个节目组如何把烂牌打出王炸。",
    image:
      "https://readdy.ai/api/search-image?query=television%20studio%20control%20room%20with%20multiple%20monitors%20showing%20colorful%20screens%20in%20warm%20evening%20light%2C%20editorial%20media%20analysis%20photography%2C%20amber%20tones&width=700&height=820&seq=excl-review-01&orientation=portrait",
  },
];

export const flashes = [
  { time: "刚刚", tag: "加急", text: "某顶流工作室发布声明，对网络谣言保留法律追究权利，全文三点回应此事。", heat: 999 },
  { time: "12:34", tag: "速递", text: "新片档期调整正式官宣，原定国庆上映改为贺岁档，片方称为了更好的排片。", heat: 876 },
  { time: "11:58", tag: "独家", text: "路透图再添佐证：两位传闻主角先后现身同一街区的咖啡馆，间隔仅二十分钟。", heat: 812 },
  { time: "11:02", tag: "首发", text: "头部主播新带货节奏曝光，内部通知显示下月将砍掉近三成美妆坑位。", heat: 754 },
  { time: "10:27", tag: "快讯", text: "某综艺节目官宣停播一季，官方表示将全面改版升级，明年Q1回归。", heat: 690 },
  { time: "09:41", tag: "加急", text: "盛典主办方发布补充说明，回应红毯名单有变传言，确认名单不再更改。", heat: 621 },
];

export const hotRank = [
  { rank: 1, title: "顶流剧组档期暗战内幕持续发酵", score: 98.6, trend: "up", tag: "热" },
  { rank: 2, title: "选秀淘汰名单提前流出引热议", score: 96.1, trend: "new", tag: "新" },
  { rank: 3, title: "黄牛锁票软件被点名 深夜加急", score: 92.4, trend: "up", tag: "热" },
  { rank: 4, title: "小花新剧造型首曝 路透疯传", score: 89.7, trend: "up", tag: "热" },
  { rank: 5, title: "头部主播带货规则下周收紧", score: 85.2, trend: "down", tag: "缓" },
  { rank: 6, title: "年度盛典红毯名单确定 三顶流同台", score: 81.8, trend: "up", tag: "热" },
  { rank: 7, title: "综艺主持人塌房传闻双方各执一词", score: 78.3, trend: "down", tag: "缓" },
  { rank: 8, title: "演唱会实名制细则本周落地", score: 74.5, trend: "new", tag: "新" },
];

export const categories = [
  {
    id: "c1",
    name: "影视热映",
    count: 128,
    desc: "新片定档、片场路透、票房一线数据",
    image:
      "https://readdy.ai/api/search-image?query=cinema%20projector%20light%20beam%20in%20dark%20theater%20with%20warm%20amber%20glow%2C%20editorial%20category%20icon%20photography%2C%20warm%20tones&width=520&height=360&seq=cat-film-01&orientation=landscape",
    posts: ["新片定档贺岁档", "古装大剧杀青宴曝光", "票房单日破纪录"],
  },
  {
    id: "c2",
    name: "综艺现场",
    count: 96,
    desc: "节目名单、导师动向、录制路透",
    image:
      "https://readdy.ai/api/search-image?query=glowing%20stage%20with%20circular%20spotlight%20and%20confetti%20in%20warm%20coral%20and%20gold%2C%20editorial%20variety%20category%20photography%2C%20energetic&width=520&height=360&seq=cat-show-01&orientation=landscape",
    posts: ["爆款综艺名单外流", "导师人选一换再换", "录制现场粉丝失控"],
  },
  {
    id: "c3",
    name: "乐坛声浪",
    count: 84,
    desc: "演唱会、新歌首发、音乐节动态",
    image:
      "https://readdy.ai/api/search-image?query=vinyl%20record%20and%20stage%20speaker%20with%20warm%20backlight%20in%20cream%20studio%2C%20editorial%20music%20category%20photography%2C%20warm%20gold%20tones&width=520&height=360&seq=cat-music-01&orientation=landscape",
    posts: ["音乐节官宣全阵容", "新歌MV幕后花絮", "演唱会门票秒罄"],
  },
  {
    id: "c4",
    name: "主播红人",
    count: 112,
    desc: "头部主播动态、带货行业观察",
    image:
      "https://readdy.ai/api/search-image?query=ring%20light%20and%20smartphone%20stand%20on%20warm%20studio%20table%20with%20coral%20background%2C%20editorial%20live%20streaming%20category%20photography&width=520&height=360&seq=cat-streamer-01&orientation=landscape",
    posts: ["新带货节奏曝光", "坑位费普调引争议", "头部主播深夜回应"],
  },
  {
    id: "c5",
    name: "品牌热议",
    count: 67,
    desc: "代言动向、商标纠纷、资本动向",
    image:
      "https://readdy.ai/api/search-image?query=brand%20logos%20and%20magnifying%20glass%20on%20warm%20cream%20desk%20with%20coffee%2C%20editorial%20business%20category%20photography%2C%20warm%20tone&width=520&height=360&seq=cat-brand-01&orientation=landscape",
    posts: ["改名风波资本棋局", "代言人更换内情", "商标抢注战况"],
  },
  {
    id: "c6",
    name: "行业观察",
    count: 52,
    desc: "票务、排片、工业化深度拆解",
    image:
      "https://readdy.ai/api/search-image?query=bar%20chart%20and%20analytics%20dashboard%20on%20warm%20paper%20background%20with%20amber%20accents%2C%20editorial%20industry%20analysis%20photography&width=520&height=360&seq=cat-industry-01&orientation=landscape",
    posts: ["黄牛锁票软件被点名", "烂片是怎么被催出来的", "工业化杀死创作吗"],
  },
];

export const faqs = [
  {
    q: "吃瓜前线的独家首发内容来源可靠吗？",
    a: "我们坚持两条铁律：一是每条独家内容必须通过多渠道交叉核实，涉及当事人或机构的声明会第一时间补全；二是标注为传闻待证实的内容绝不冒充既成事实。宁可慢一分钟发实锤，也不抢跑传播未经核实的猜测。",
  },
  {
    q: "为什么同一条新闻在首页会反复加急更新？",
    a: "吃瓜前线速递快讯采用滚动核实机制。当事件出现新的官方回应、新增路透图或当事人发声时，编辑会即时更新原文并打上更新标记。刷新越快、看到的片段越新，这正是首页定位——第一时间放出关键信息，不用等全网汇总。",
  },
  {
    q: "如何向吃瓜前线投稿或提供独家线索？",
    a: "你可以在页面底部的线索征集表单中留下联系方式与线索描述，并勾选内容类型。请尽量附带可核实的时间、来源或截图。经核实的独家线索被采纳后，我们会在 48 小时内与你沟通稿酬与署名方式，并对线索来源严格保密。",
  },
  {
    q: "看到某个瓜但不想站队，评论区怎么表态更理性？",
    a: "欢迎理性讨论。我们倡导先问真假、再论对错的吃瓜观：在官方信息公布前，尽量避免对当事人做出有罪推定；转载观点请注明来源；涉及造谣或网暴的评论会被平台处理。吃瓜有度，理性是硬道理。",
  },
  {
    q: "吃瓜前线的付费或加急内容如何订阅？",
    a: "目前独家抢先深度内容向全部用户免费开放，暂无付费墙。你只需在下方订阅每日速递，就能在早高峰与晚间两个时段收到聚合了当日独家、热榜与分类要点的快讯邮件，不错过任何一线新瓜。",
  },
];

export const testimonials = [
  {
    name: "在逃猹猹",
    role: "追剧吃瓜常客",
    quote: "每天早上一睁眼就先刷吃瓜前线的速递，比我自己蹲热搜还快。独家线报是真的准，好几次全网都还没动静。",
  },
  {
    name: "理性吃瓜派",
    role: "影视行业从业者",
    quote: "难得遇到会把传闻和实锤分开标注的号。吃瓜前线的独家深挖逻辑清晰，时间线梳理得特别专业，路转粉了。",
  },
  {
    name: "瓜田守卫",
    role: "重度吃瓜用户",
    quote: "加急更新那段跑马灯太懂我了，刷新越快料越足。界面清爽不花哨，点进去就是干货，不像别家一堆标题党。",
  },
  {
    name: "夜猫子用户",
    role: "音乐节爱好者",
    quote: "盛典红毯名单、演唱会实名制细则这种一手信息都是首发。关键是排版舒服，深夜刷也不刺眼，被圈粉了。",
  },
];

export const footerRelated = [
  "独家抢先专区",
  "今日热点榜单",
  "速递快讯时间线",
  "娱乐吃瓜分类",
  "吃瓜指南 FAQ",
  "关于我们与口碑",
];

export const contact = {
  brand: "吃瓜前线",
  slogan: "第一时间，吃一线新瓜",
  intro:
    "吃瓜前线是专注娱乐八卦与网络热门话题的速递快讯平台。我们以独家抢先、首发加急、滚动核实为核心，做华语网络最懂吃瓜人的内容门户。",
  email: "contact@chigua-example.com",
  subscribe: "news@chigua-example.com",
};